import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  inject,
  viewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { VoicemailStore } from '@services';
import { VoicemailPhoneTab } from '../../../../voicemail.tokens';
import { VoicemailSettingsComponent } from '../../../voicemail/settings/voicemail-settings.component';

@Component({
  selector: 'provider-portal-settings-phone',
  imports: [VoicemailSettingsComponent],
  templateUrl: './phone.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsPhoneComponent implements OnInit, VoicemailPhoneTab {
  private readonly store = inject(VoicemailStore);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);
  private readonly phoneSettings = viewChild(VoicemailSettingsComponent);

  ngOnInit(): void {
    // Settings tabs retain their components. Re-entering Phone must re-read the scheduling
    // destination even when ngOnInit is not run again or the store already has a snapshot.
    // Only settings are re-read: the voicemail list is not shown here, and a background refresh
    // keeps the current screen in place instead of flashing a loading state.
    this.route.queryParamMap
      .pipe(
        map(params => params.get('tab') === 'phone'),
        distinctUntilChanged(),
        filter(active => active),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        if (this.store.settings()) void this.store.reloadSettings();
        else if (!this.store.loading()) void this.store.load();
      });
  }

  requestLeave(): Promise<boolean> {
    return this.phoneSettings()?.requestLeave() ?? Promise.resolve(true);
  }

  backToCalls(): void {
    void this.router.navigate(['/calls']);
  }
}
